export const convertToCurrencyWithoutSign = (value) => 
{
	return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: (parseInt(value) !== parseFloat(value) ? 2 : 0),
  }).format(value)
}